module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ded01#ded-01",
      "id": "ded01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/epi01#epi-01",
      "id": "epi01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface01#preface-01",
      "id": "preface01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cha01#cha-01",
      "id": "cha01"
    }
  }, [_vm._v("I - Into the Unknown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cha02#cha-02",
      "id": "cha02"
    }
  }, [_vm._v("II - Learning to Live")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha03#cha-03",
      "id": "cha03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III - Eggs, Guards, and Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha04#cha-04",
      "id": "cha04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV - Medicines and Recipes, or How to Outwit Circumstances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha05#cha-05",
      "id": "cha05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V - A Place of One’s Own")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha06#cha-06",
      "id": "cha06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI - A Mixed Blessing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha07#cha-07",
      "id": "cha07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII - Sugar-and Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha08#cha-08",
      "id": "cha08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII - Threat of Anarchy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha09#cha-09",
      "id": "cha09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX - Saints, Priests, and Preachers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha10#cha-10",
      "id": "cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X - More Saints, Priests, and Preachers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha11#cha-11",
      "id": "cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI - Living for What?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha12#cha-12",
      "id": "cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII - Rescue from the Clouds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha13#cha-13",
      "id": "cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII - Last Days at Weihsien")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cha14#cha-14",
      "id": "cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV - After It Was All Over")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/copy01#copy-01",
      "id": "copy01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "id": "ata_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184bee3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc01.vue
// module id = 69
// module chunks = 0